import { httpCreate } from "./http";
import conf from "@/config";

const http = httpCreate(conf.apipath + "/jobApply");

export const jobApply = {
  applyList(jobRecruitId, params) {
    return http.get(`/applyList/${jobRecruitId}`, { params });
  },
  attachment(id) {
    return http.get(`/${id}`);
  }
};